import { Injectable } from "@angular/core";
import { AvailableResult, NativeBiometric } from "capacitor-native-biometric";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BiometricService {
  biometricChange$ = new Subject<boolean>(); // no initial value

  async isAvailable(): Promise<AvailableResult> {
    const result = await NativeBiometric.isAvailable();
    return result;
  }

  async authenticate(options): Promise<boolean> {
    try {
      await NativeBiometric.verifyIdentity(options);
      return true;
    } catch (error) {
      return false;
    }
  }
}
